/*
 * @Description: '关于我们'页面所有路由
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-02-27 20:12:42
*/

export default [
    {
        path: 'about',
        component: resolve => require(['@/views/about'], resolve),
        name: 'About',
        meta: {
            nav: '关于我们'
        }
    },
    // {
    //     path: 'about/:id',
    //     component: resolve => require(['@/views/about/detail'], resolve),
    //     name: 'about_Detail',
    //     meta: {
    //         nav: '产品中心'
    //     }
    // },

]



// WEBPACK FOOTER //
// ./src/router/about.js